import axios from 'axios/index';
import store from '../store';

axios.interceptors.response.use(
  response => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      await store.dispatch('signOut');
      window.location.href = '/';
    }
    return Promise.reject(error);
  },
);



// WEBPACK FOOTER //
// ./src/addons/api.js